import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type ExamName = {
  id: number;
  name: string;
  slug: string;
  mainImage?: {
    id: number;
    alt: string;
    url: string;
    filename?: string;
  };
  secondImage?: {
    id: number;
    alt: string;
    url: string;
    filename?: string;
  };
  altText?: string;
  mainDescription?: string;
  otherDescription?: string;
  ranking?: number;
};

export type ExamPost = {
  id: number;
  name: string;
  slug: string;
  heading?: string;
  mainParagraph?: string;
  date: string;
  updatedAt?: string;
  mainImage?: {
    id: number;
    alt: string;
    url: string;
    filename?: string;
  };
  thumbnailImage?: {
    id: number;
    alt: string;
    url: string;
    filename?: string;
  };
  examName: {
    id: number;
    name: string;
    slug: string;
  };
  isCategory?: boolean;
  isPost?: boolean;
};

export type TopArticleItem = {
  id?: string;
  examName?: ExamName;
  examPost: ExamPost;
};

export type ExamWithPosts = ExamName & {
  posts: ExamPost[];
};

interface ExamsHomeData {
  readyStatus: "invalid" | "request" | "success" | "failure";
  examNames: ExamName[];
  topArticles: TopArticleItem[];
  examPosts: ExamPost[]; // All exam posts for filtering
  error: any;
}

export const initialState: ExamsHomeData = {
  readyStatus: "invalid",
  examNames: [],
  topArticles: [],
  examPosts: [],
  error: null,
};

const examsHomeSlice = createSlice({
  name: "examsHomeData",
  initialState,
  reducers: {
    updateExamsHomeData: (state: ExamsHomeData, { payload }: PayloadAction<any>) => {
      state.examNames = payload?.examNames || [];
      state.topArticles = payload?.topArticles || [];
      state.examPosts = payload?.examPosts || [];
    },
    updateExamsHomeReadyStatus: (
      state: ExamsHomeData,
      { payload }: PayloadAction<"invalid" | "request" | "success" | "failure">,
    ) => {
      state.readyStatus = payload;
    },
    updateExamsHomeError: (state: ExamsHomeData, { payload }: PayloadAction<any>) => {
      state.error = payload;
    },
    resetExamsHomeData: (state: ExamsHomeData) => {
      state.readyStatus = "invalid";
      state.examNames = [];
      state.topArticles = [];
      state.examPosts = [];
      state.error = null;
    },
  },
});

export const {
  updateExamsHomeData,
  updateExamsHomeReadyStatus,
  updateExamsHomeError,
  resetExamsHomeData,
} = examsHomeSlice.actions;

export default examsHomeSlice.reducer;
